// Libraries
import React, { useState } from 'react'
import { PlusCircle } from '@styled-icons/bootstrap'
import { Button as BtnLinkAntd } from 'antd'
import PropTypes from 'prop-types'
// Components
import { ModalSupport } from '../../HeaderMenu/Modals/Support'
import { Spinner } from '../../Spinner'
// Styled Components
import { AddSkillButtonBox, WrapperAddSkill, WrapperNotFound } from '../Modals/styles'
import { ContainerNotFound } from './styles'
// Constants
import { GrayColor, OrangeColor, TOOLTIP_TEXT } from '../../../constants/constants'

export const AddNotFound = ({ allowAdd = false, isSaving = false, addNewSkill }) => {
  const [openSupport, setOpenSupport] = useState(false)

  const simpleNotFound = (
    <WrapperNotFound onClick={addNewSkill}>
      <div>{"Can't find your skill?"}</div>
    </WrapperNotFound>
  )

  const contactNotFound = (
    <ContainerNotFound>
      {TOOLTIP_TEXT.itemNotFound}
      <BtnLinkAntd
        type='link'
        onClick={() => setOpenSupport(true)}
        style={{ color: `${GrayColor}`, paddingLeft: '5px' }}>
        <u>Support</u>
      </BtnLinkAntd>
      <ModalSupport open={openSupport} setModal={setOpenSupport} />
    </ContainerNotFound>
  )

  const addButton = (
    <AddSkillButtonBox onClick={addNewSkill}>
      <PlusCircle size={25} color={OrangeColor} />
      <p>Add new item</p>
    </AddSkillButtonBox>
  )

  return allowAdd ? (
    <WrapperAddSkill>
      {isSaving ? (
        <Spinner top='10px' loadingText='Saving...' />
      ) : (
        <>
          {simpleNotFound}
          {addButton}
        </>
      )}
    </WrapperAddSkill>
  ) : (
    contactNotFound
  )
}

AddNotFound.propTypes = {
  allowAdd: PropTypes.bool,
  isSaving: PropTypes.bool,
  addNewSkill: PropTypes.func
}
